export const sanitizeInput = (input) => {
  if (!input) return "";
  return input
    .trim() // Remove leading/trailing whitespace
    .replace(/[<>]/g, "") // Remove HTML tags
    .replace(/[^\w\s\-'\.]/g, "") // Keep only word characters, spaces, hyphens, apostrophes, and periods
    .replace(/\s+/g, " "); // Replace multiple spaces with single space
};

export const sanitizeText = (text) => {
  if (!text) return "";
  return text
    .trim() // Remove leading/trailing whitespace
    .replace(/[<>]/g, "") // Remove HTML tags
    .replace(/[^\w\s\-'\.]/g, "") // Keep only word characters, spaces, hyphens, apostrophes, and periods
    .replace(/\s+/g, " "); // Replace multiple spaces with single space
};

export const sanitizeDescription = (text) => {
  if (!text) return "";
  return text
    .trim()
    .replace(/[<>]/g, "") // Remove < and > to prevent HTML injection
    .replace(/&/g, "&amp;") // Encode ampersands
    .replace(/"/g, "&quot;") // Encode quotes
    .replace(/'/g, "&#x27;") // Encode apostrophes
    .substring(0, 2000); // Limit length for descriptions
};

export const sanitizeEmail = (email) => {
  if (!email) return "";

  return email
    .trim() // Remove leading/trailing whitespace
    .toLowerCase() // Normalize to lowercase
    .replace(/\s+/g, "") // Remove all internal whitespace
    .replace(/[<>]/g, "") // Remove potential HTML tags
    .replace(/[^\w@._%+-]/g, ""); // Remove any characters not allowed in email addresses
};

export const sanitizePhone = (phone) => {
  return phone.replace(/\D/g, ""); // Remove all non-digit characters
};

export const sanitizeUsbcId = (usbcId) => {
  if (!usbcId) return "";
  // Remove all non-digit characters and limit to 15 digits
  return usbcId.replace(/\D/g, "").slice(0, 15);
};

export const sanitizeUrl = (url) => {
  if (!url) return "";

  // Trim whitespace
  let cleanUrl = url.trim();

  // If it doesn't start with http:// or https://, add https://
  if (!cleanUrl.match(/^https?:\/\//i)) {
    cleanUrl = `https://${cleanUrl}`;
  }

  return cleanUrl;
};

export const isValidUrl = (url) => {
  if (!url) return false;

  try {
    // First, ensure it has a protocol
    const urlWithProtocol = url.startsWith("http") ? url : `https://${url}`;
    new URL(urlWithProtocol);
    return true;
  } catch {
    return false;
  }
};
